import { jwtDecode } from 'jwt-decode';

// Define types for the decoded token payload
interface JwtPayload {
    Id?: string;
    doctor_id?: string;
    role?: string;
    exp?: number;
}

const setToken = (token: string): void => {
    localStorage.setItem('jwt_token', JSON.stringify(token));
};

const getToken = (): string | null => {
    const token = localStorage.getItem("jwt_token");
    return token ? JSON.parse(token) : null;
};

const getUserId = (): string | null => {
    const token = getToken();
    if (token) {
        const payload = jwtDecode<JwtPayload>(token);
        return payload?.Id ?? null;
    }
    return null;
};

const getUserIdChat = (): string | null => {
    const token = getToken();
    if (token) {
        const payload = jwtDecode<JwtPayload>(token);
        return payload?.doctor_id ?? null;
    }
    return null;
};

const getUserRole = (): string | null => {
    const token = getToken();
    if (token) {
        const payload = jwtDecode<JwtPayload>(token);
        return payload?.role ?? null;
    }
    return null;
};

const isLoggedIn = (): boolean => {
    const token = getToken();
    if (token) {
        const payload = jwtDecode<JwtPayload>(token);
        return payload.exp ? Date.now() < (payload.exp * 1000) : false;
    }
    return false;
};

const logOut = (): void => {
    localStorage.clear();
};

export const authService = {
    logOut,
    getToken,
    setToken,
    getUserId,
    getUserRole,
    getUserIdChat,
    isLoggedIn
};
